import { Link } from 'react-router-dom';

const TEASERS = [
  {
    to: '/services',
    title: 'Services',
    body: 'Hardscape, design, mowing, mulch, and seasonal cleanups for Corning and nearby.',
  },
  {
    to: '/gallery',
    title: 'Gallery',
    body: 'Photos of real lawns and landscapes we have worked on.',
  },
  {
    to: '/contact',
    title: 'Free quote',
    body: 'Book your estimate—call or Facebook message and we’ll get you on the calendar.',
  },
];

export default function HomePage() {
  return (
    <section className="section services home-teasers">
      <div className="container">
        <h2 className="home-teasers-heading">Where to next</h2>
        <ul className="service-grid">
          {TEASERS.map(({ to, title, body }) => (
            <li key={to}>
              <Link to={to} className="service-teaser-card">
                <h3>{title}</h3>
                <p>{body}</p>
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
